import axios from 'axios';
import ErrorModal from 'components/ErrorModal';

const ins = axios.create({
  timeout: 10 * 1000
});

export function handleApiRes(promise, ignore = []) {
  return promise
    .then(res => [null, res.data.result])
    .catch(err => {
      if (err.type === 'api') {
        if (ignore && !ignore.includes(err.data.error_code)) {
          ErrorModal.open();
          window.Sentry.withScope(function (scope) {
            const { url, baseURL, method } = err.config;
            const path = url.replace(baseURL, '');
            scope.setFingerprint([method, path]);
            window.Sentry.captureException(err);
          });
        }
      } else {
        ErrorModal.open();
        window.Sentry.captureException(err);
      }
      return [err, null];
    });
}

const setToken = token => {
  ins.defaults.headers['Authorization'] = `Bearer ${token}`;
};

const getOpenid = () => sessionStorage.getItem('openid');
const api = {
  setBaseUrl(baseUrl) {
    ins.defaults.baseURL = baseUrl;
  },
  getJoined() {
    return handleApiRes(
      ins
        .get('/user/joined', {
          params: {
            openid: getOpenid()
          }
        })
        .then(res => {
          setToken(res.headers['x-token']);
          return res;
        })
    );
  },
  postVerify({ code, mobile, identify }) {
    return handleApiRes(
      ins.post('/user/verify', {
        code,
        mobile,
        identify
      }),
      [-1003, -1004, -1006]
    );
  },
  postUserInfo({
    mobile,
    identify,
    code,
    cnl,
    unionid,
    nickname,
    createAccount,
    trading
  }) {
    return handleApiRes(
      ins.post('/user/info', {
        mobile,
        identify,
        code,
        cnl,
        unionid,
        nickname,
        createAccount,
        trading
      })
    );
  },
  postScreen({ province, city, area }) {
    return handleApiRes(
      ins.post('/user/screen', {
        province,
        city,
        area
      })
    );
  },
  getPic() {
    return `${ins.defaults.baseURL}/user/pic?openid=${getOpenid()}`;
  }
};

ins.interceptors.request.use(
  config => config,
  err => Promise.reject(err)
);

ins.interceptors.response.use(
  async response => {
    const { data, config } = response;
    if (data.error_code === -1004) {
    }
    if (data && !data.ok) {
      const { url, baseURL, method } = config;
      const path = url.replace(baseURL, '');
      let msg = `${method}:${path}=>${data.message}`;
      if (config.params) {
        msg += 'params:' + JSON.stringify(config.params);
      }
      if (config.data) {
        msg += 'data:' + JSON.stringify(config.data);
      }
      const err = Error(msg);
      err.type = 'api';
      err.config = config;
      err.data = data;
      return Promise.reject(err);
    }
    return response;
  },
  err => Promise.reject(err)
);

export default api;
